import SigninOidc from './SigninOidc';

const SigninOidcConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'signin-oidc',
      element: <SigninOidc />,
    },
  ],
};

export default SigninOidcConfig;
